import { useEffect } from 'react';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import { GET_SYSTEM_CURRENCIES } from '../constants/aryGraphqlSchemas';
import arySystemSettings from '../constants/arySystemSettings';
import { useAryLazyQuery } from './useAryGraphql';
import useSystemSettingsContext from './useSystemSettingsContext';

function getCurrencyByCode(currencies, code) {
  if (!currencies || !currencies.length) return null;
  const desireCurrency = currencies.find((currency) => currency.code === code);
  return desireCurrency;
}

function getCurrencyByTitle(currencies, title) {
  if (!currencies || !currencies?.length) return null;
  const desireCurrency = currencies?.find(
    (currency) => currency.title === title
  );
  return desireCurrency;
}

const useShowSystemCurrency = () => {
  const { t } = useFrameworkTranslation();
  const { systemSettings } = useSystemSettingsContext();

  const [getSystemCurrencies, { data: getSystemCurrenciesQueryData }] =
    useAryLazyQuery({
      gqlConfig: GET_SYSTEM_CURRENCIES,
      items: `
        totalCount
        currencies {
          code
          title
        }
      `
    });

  useEffect(() => {
    getSystemCurrencies({
      language: systemSettings?.[arySystemSettings.systemLanguage],
      pagination: {
        pageIndex: 0,
        pageCount: 10000
      }
    });
  }, []);

  function showCurrency({ code, title }) {
    if (code) {
      if (systemSettings[arySystemSettings?.showCurrencyByTitle]) {
        return t(
          getCurrencyByCode(getSystemCurrenciesQueryData?.currencies, code)
            ?.title
        );
      }
      return code;
    }
    if (title) {
      if (systemSettings[arySystemSettings?.showCurrencyByTitle]) {
        return t(title);
      }
      return getCurrencyByTitle(getSystemCurrenciesQueryData?.currencies, title)
        ?.code;
    }
    return null;
  }

  return showCurrency;
};

export default useShowSystemCurrency;
